// extracted by mini-css-extract-plugin
export default {"input":"X9-z","button":"Y9-z","selected":"Z9-z","unavailable":"_9-z","oos":"a--z","image":"b--z","paperCutDisabledOverlay":"c--z"};